import './style.css'
import {Button, Input} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import {useEffect, useState} from "react";
import { getAllChanels, getBanner, getFilesList, setUpdateBanner} from "../../API/api";
import {useNavigate, useParams} from "react-router-dom";
import {RightInfoBanerTicker} from "../../modules/right-info-baner-ticker/RightInfoBanerTicker";
import {SelectDates} from "../../modules/select-dates/SelectDates";
import BannerInputSelect from "../../components/banner-input-select";
import {FileUpload} from "../../modules/File-Upload/FileUpload";
import {selectMonth} from "../../store/select-month";

const EditBanner = () => {
    const {id} = useParams();
    const {activeMonth} = useSelector((store) => store.month)
    const {activeChanel} = useSelector((store) => store.chanel)
    const { userName } = useSelector((store) => store.userName)
    const navigate = useNavigate()
    const [selectDates, setSelectDates] = useState([])
    const [priceRek, setPriceRek] = useState(0)
    const [bannerRU, setBannerRU] = useState('')
    const [bannerKG, setBannerKG] = useState('')
    const monthName = (date) => (new Date(Date.parse(date)).toLocaleString('ru', {
        month: 'long', year: 'numeric'
    }))
    const dispatch = useDispatch();
    // Calendar days table
    const daysWeekName = ['ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС'];

    //useForm
    const {
        register,
        handleSubmit,
        formState: {errors},
        reset,
    } = useForm();

    const [chanels, setChanels] = useState([])
    const getChanels = async () => {
        const data = await getAllChanels();
        setChanels(data)
    }
    useEffect(() => {
        getChanels();
    },[]);

    const onSubmit = async (data) => {
        if (errors?.name) {
            console.log(errors?.name?.message);
        }
        try {
            //Add mocked data
            data.user = userName
            data.banner_ru = bannerRU
            data.banner_kg = bannerKG
            data.days = selectDates.sort((a, b) => a - b)
            // next data
            // console.log(data);
            await setUpdateBanner(localStorage.getItem("access_token"), id, data)
            navigate('/banner')
        } catch (error) {
            console.dir(error);
            throw new Error("Что-то не так с пост запросом");
        }
    }

    const parseRussianMonth = (str) => {
        if (!str) return null;

        // Приводим к нижнему регистру и убираем лишние символы вроде "г."
        const cleanStr = str.toLowerCase().replace(/[^а-я0-year0-9\s]/g, '').trim();

        const months = {
            'январь': 0, 'февраль': 1, 'март': 2, 'апрель': 3, 'май': 4, 'июнь': 5,
            'июль': 6, 'август': 7, 'сентябрь': 8, 'октябрь': 9, 'ноябрь': 10, 'декабрь': 11
        };

        // Разбиваем строку по пробелам (ожидаем [ "октябрь", "2026" ])
        const parts = cleanStr.split(/\s+/);
        const monthName = parts[0];
        const year = parseInt(parts[1], 10);

        if (months[monthName] !== undefined && !isNaN(year)) {
            // Создаем дату на 1-е число этого месяца
            return new Date(year, months[monthName], 1);
        }

        return null;
    };

    const [dayPerMonth, setDayPerMonth] = useState()
    const currentDays = () => {
        setDayPerMonth(new Date(
            new Date(activeMonth).getFullYear(),
            new Date(activeMonth).getMonth()+1, 0).getDate())
    }
    useEffect(() => {
        currentDays()
    }, [activeMonth])

    // Get name Day of week
    const getWeekDay = (date) => {
        let days = ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'];

        return days[date.getDay()];
    }
    const getNumberWeekDay = (date) => (date.getDay())


    // Other Way Calendar
    const [customArrDayMonth, setCustomArrDayMonth] = useState([])

    const divCalendarTable = () => {
        setCustomArrDayMonth([])
        const month = new Date(activeMonth).getMonth()
        const year = new Date(activeMonth).getFullYear()
        const first = getWeekDay(new Date(year, month, 1))
        const indexFirstDay = daysWeekName.indexOf(first)
        const indexLastDay = getNumberWeekDay(new Date(year, month, dayPerMonth))

        for (let i=0; i < indexFirstDay; i++) {
            setCustomArrDayMonth(oldArray => [...oldArray, ""])
        }
        for (let i=1; i <= dayPerMonth; i++) {
            setCustomArrDayMonth(oldArray => [...oldArray, i])
        }
        if (indexLastDay !== 0) {
            for (let i = indexLastDay; i < 7; i++) {
                setCustomArrDayMonth(oldArray => [...oldArray, ""])
            }
        }
    }

    useEffect(() => {
        // calendarTable()
        divCalendarTable()
    }, [activeMonth, chanels, dayPerMonth])

    // Get Data
    const [dataBanners, setDataBanners] = useState(null)
    const getDataBanners = async () => {
        const data = await getBanner(localStorage.getItem("access_token"),id);
        setDataBanners(data)
    }
    useEffect(() => {
        getDataBanners();
    },[id]);

    useEffect(() => {
        if (dataBanners) {
            setSelectDates(dataBanners?.days)
            setBannerRU(dataBanners?.banner_ru)
            setBannerKG(dataBanners?.banner_kg)
            // setStatus(dataMp?.status)
            // setReklama(dataMp?.reklama)
            reset(dataBanners)

            if (dataBanners.month) {
                const parsedDate = parseRussianMonth(dataBanners.month);

                if (parsedDate) {
                    // Записываем дату в стор.
                    // В зависимости от того, что ждет ваш редюсер, передайте:
                    // parsedDate (объект даты) или parsedDate.toISOString() (строку)
                    dispatch(selectMonth(parsedDate.toISOString()));
                }
            }
        }
    },[dataBanners])

    // Get Banner List from Server
    const [files, setFiles] = useState([])
    const getFiles = async () => {
        if (chanels) {
            const data = await getFilesList(
                localStorage.getItem("access_token"),
                `${chanels[activeChanel]?.id}`,
                `bannerUrl`
            );
            // Убираем лишние файлы
            const filter = data.filter((el) =>
                el.split('.').at(-1) === "jpg" ||
                el.split('.').at(-1) === "png"
            )
            setFiles(filter)
        }
    }

    useEffect(() => {
        if (chanels.length > 0) {
            getFiles();
        }
    },[chanels]);


    return (
        <div className="add-banner-page container">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mp-head">
                    <div className="mp-head-left">
                        <div className="mp-head_text">
                            <div className="mp-head_text_left">Телеканал:</div>
                            <div className="mp-head_text_right">{chanels[activeChanel]?.chanel}</div>
                        </div>
                        <div className="mp-head_text">
                            <div className="mp-head_text_left">Пользователь:</div>
                            <div className="mp-head_text_right">{userName}</div>
                        </div>
                        <div className="mp-head_text">
                            <div className="mp-head_text_left">Брэнд:</div>
                            <div className="mp-head_text_right">
                                <Input
                                    className="mp-head_input"
                                    placeholder="Название"
                                    {...register("name",{
                                        required: true
                                    })}
                                />
                            </div>
                        </div>
                        <div className="mp-head_text">
                            <div className="mp-head_text_left">Баннер РУ:</div>
                            <div className="mp-head_text_right">
                                <BannerInputSelect
                                    files={files}
                                    itemValue={bannerRU}
                                    setItemValue={setBannerRU}
                                />
                            </div>
                        </div>
                        <div className="mp-head_text">
                            <div className="mp-head_text_left">Баннер КГ:</div>
                            <div className="mp-head_text_right">
                                <BannerInputSelect
                                    files={files}
                                    itemValue={bannerKG}
                                    setItemValue={setBannerKG}
                                />
                            </div>
                        </div>
                        <div className="mp-head_text">
                            <FileUpload
                                selectFolder={"bannerUrl"}
                                chanels={chanels}
                                getFiles={getFiles}
                            />
                            <Button
                                variant="outlined"
                                onClick={() => navigate("/list/bannerUrl")}
                            >Посмотреть все файлы</Button>
                        </div>
                        <div className="mp-head_text">
                            <div className="mp-head_text_left">Стоимость:</div>
                            <Input
                                className="mp-head_input"
                                placeholder="Цена символа"
                                type="number"
                                value={priceRek}
                                onChange={(e) => {
                                    setPriceRek(e.target.value);
                                }}
                            />
                        </div>
                        <div className="mp-head_text">
                        <div className="mp-head_text_left">Месяц:</div>
                        <div className="mp-head_text_right">
                            <Input disabled defaultValue={activeMonth} {...register(`month`)}  />
                        </div>
                    </div>
                        {/*<div className="mp-head_text">*/}
                        {/*    <div className="mp-head_text_left">Выбранные даты:</div>*/}
                        {/*    <div className="mp-head_text_right">*/}
                        {/*        {selectDates?.sort((a, b) => a - b).map((el) => (`${el} ${monthName(activeMonth)}`))}*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>

                    <div className={`mp-head-right`} style={{maxWidth:'350px'}}>
                        <RightInfoBanerTicker
                            selectDates={selectDates}
                            priceRek={priceRek}
                            monthName={monthName(activeMonth)}
                        />
                    </div>
                </div>
                <SelectDates
                    selectDates={selectDates}
                    setSelectDates={setSelectDates}
                    daysWeekName={daysWeekName}
                    customArrDayMonth={customArrDayMonth}
                />
            <div>
                <Button type={"submit"} variant="contained">Сохранить</Button>
                <Button variant="outlined" onClick={() => navigate(-1)}>Отмена</Button>
            </div>
            </form>
        </div>
    )
}

export default EditBanner